export default __webpack_public_path__ + "static/media/TVSraider_LateralIzq.568db626.webp";